module.exports = __webpack_public_path__ + "img/principal_activity.047540d7.png";